import { useSSRSelector } from 'src/redux';
import getDummyOrActualContactDetails from 'src/utils/getContactDetails';

const useStoreContactDetails = (hideOwnerPhone = false) => {
  const storeData = useSSRSelector((state) => state.storeReducer.store);
  return getDummyOrActualContactDetails(storeData, true, hideOwnerPhone);
};

export default useStoreContactDetails;
